module.exports = __webpack_public_path__ + "static/media/img.3229a2bd.png";